// FETCH ALL YARN_INFORMATION
export const FETCH_YARN_INFORMATION_REQUEST = 'FETCH_YARN_INFORMATION_REQUEST';
export const FETCH_YARN_INFORMATION_SUCCESS = 'FETCH_YARN_INFORMATION_SUCCESS';
export const FETCH_YARN_INFORMATION_FAILURE = 'FETCH_YARN_INFORMATION_FAILURE';

// FETCH ALL YARN_MASTER_WITHOUT_STYLE
export const FETCH_YARN_MASTER_WITHOUT_STYLE_REQUEST = 'FETCH_YARN_MASTER_WITHOUT_STYLE_REQUEST';
export const FETCH_YARN_MASTER_WITHOUT_STYLE_SUCCESS = 'FETCH_YARN_MASTER_WITHOUT_STYLE_SUCCESS';
export const FETCH_YARN_MASTER_WITHOUT_STYLE_FAILURE = 'FETCH_YARN_MASTER_WITHOUT_STYLE_FAILURE';

// CREATE YARN_INFORMATION
export const CREATE_YARN_INFORMATION_REQUEST = 'CREATE_YARN_INFORMATION_REQUEST';
export const CREATE_YARN_INFORMATION_SUCCESS = 'CREATE_YARN_INFORMATION_SUCCESS';
export const CREATE_YARN_INFORMATION_FAILURE = 'CREATE_YARN_INFORMATION_FAILURE';

// FETCH SINGLE PART DATA
export const FETCH_SINGLE_YARN_INFORMATION_REQUEST = 'FETCH_SINGLE_YARN_INFORMATION_REQUEST';
export const FETCH_SINGLE_YARN_INFORMATION_SUCCESS = 'FETCH_SINGLE_YARN_INFORMATION_SUCCESS';
export const FETCH_SINGLE_YARN_INFORMATION_FAILURE = 'FETCH_SINGLE_YARN_INFORMATION_FAILURE';

// UPDATE YARN_INFORMATION
export const UPDATE_YARN_INFORMATION_REQUEST = 'UPDATE_YARN_INFORMATION_REQUEST';
export const UPDATE_YARN_INFORMATION_SUCCESS = 'UPDATE_YARN_INFORMATION_SUCCESS';
export const UPDATE_YARN_INFORMATION_FAILURE = 'UPDATE_YARN_INFORMATION_FAILURE';

// DELETE YARN_INFORMATION
export const DELETE_YARN_INFORMATION_REQUEST = 'DELETE_YARN_INFORMATION_REQUEST';
export const DELETE_YARN_INFORMATION_SUCCESS = 'DELETE_YARN_INFORMATION_SUCCESS';
export const DELETE_YARN_INFORMATION_FAILURE = 'DELETE_YARN_INFORMATION_FAILURE';

// FETCH ALL YARN BY STYLE DETAIL ID
export const FETCH_YARN_BY_STYLE_DETAIL_ID_REQUEST = 'FETCH_YARN_BY_STYLE_DETAIL_ID_REQUEST';
export const FETCH_YARN_BY_STYLE_DETAIL_ID_SUCCESS = 'FETCH_YARN_BY_STYLE_DETAIL_ID_SUCCESS';
export const FETCH_YARN_BY_STYLE_DETAIL_ID_FAILURE = 'FETCH_YARN_BY_STYLE_DETAIL_ID_FAILURE';

// FETCH ALL YARN BY STYLE DETAIL ID
export const FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_REQUEST = 'FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_REQUEST';
export const FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_SUCCESS = 'FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_SUCCESS';
export const FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_FAILURE = 'FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_FAILURE';

export const FETCH_YARN_MASTER_BY_STYLE_REQUEST = 'FETCH_YARN_MASTER_BY_STYLE_REQUEST';
export const FETCH_YARN_MASTER_BY_STYLE_SUCCESS = 'FETCH_YARN_MASTER_BY_STYLE_SUCCESS';
export const FETCH_YARN_MASTER_BY_STYLE_FAILURE = 'FETCH_YARN_MASTER_BY_STYLE_FAILURE';

export const RESET_YARN_INFORMATION_INFO = 'RESET_YARN_INFORMATION_INFO';

export const CREATE_YARN_INFORMATION_FORM = 'CREATE_YARN_INFORMATION_FORM';

export const UPDATE_YARN_INFORMATION_FORM = 'UPDATE_YARN_INFORMATION_FORM';
